import { get, put, post, patch, del } from "helpers/api_helper"
import {
  normalizeAdminListFilters,
  normalizeAdminListOptions,
  removeAdminListSearchFilter,
} from "helpers/adminListQueryPolicy"
import toastr from "toastr"

export const getClubsLeadsLocations = async filter => {
  const filters = new URLSearchParams(
    removeAdminListSearchFilter(filter)
  ).toString()
  return get(`/clubs-leads/locations?${filters}`)
}

export const getClubsLeads = async (filter, options) => {
  const filters = new URLSearchParams({
    ...normalizeAdminListFilters(filter),
    ...normalizeAdminListOptions(options),
  }).toString()
  return get(`/clubs-leads?${filters}`)
}

export const getClubLeadInfo = async id => {
  return get(`/clubs-leads/${id}`, { timeout: 10000 })
}

export const updateClubLead = (id, data, correlationId) => put(`/clubs-leads/${id}`, data, {
  timeout: 10000,
  headers: { "X-Correlation-Id": correlationId },
})

export const updateClubLeadStatus = async (id, data) => {
  let response
  try {
    response = await patch(`/clubs-leads/${id}`, data)
  } catch (error) {
    toastr.error(error.response.data?.message)
  }
  return response
}

export const deleteClubLead = async id => {
  let response
  try {
    response = await del(`/clubs-leads/${id}`)
  } catch (error) {
    toastr.error(error.response.data?.message)
  }
  return response
}
